<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Menu',
})
</script>
<template>
  <a-card title="菜单">
    <template #extra>
      <a-button  type="primary" @click="onAdd(0)">
      <PlusOutlined />
      </a-button>
    </template>

    <a-tree
        :tree-data="dataList"
        :blockNode="true"
        :autoExpandParent="true"
        :fieldNames="{title:'text',key:'id',children:'child'}"
        :show-line="true"
      >
      <template #title="{id,text,child}">
          <span style="margin-right: 50px">{{ text }}</span>
          <a-button-group>
            <a-button size="small" type="primary" @click="onAdd(id)">
                <PlusOutlined />
            </a-button>
            <a-button size="small" type="primary" @click="onEdit(id)">
                <EditOutlined />
            </a-button>
            <a-button v-if="child.length===0" size="small" type="primary" @click="onDel(id)">
                <DeleteOutlined />
            </a-button>
          </a-button-group>
      </template>
    </a-tree>

      <lanseed-form ref="form" v-model:open="open" :data="model" :rules="rules" @change="submit">
      </lanseed-form>
  </a-card>

</template>
<script setup lang="ts" name="Menu">

import { onMounted,ref,reactive,getCurrentInstance } from 'vue'
import api from '@/utils/http/service'
import { PlusOutlined,EditOutlined,DeleteOutlined } from '@ant-design/icons-vue'
import LanseedForm from '@/components/lanseed/form.vue'
  const dataList=ref<Array<any>>([])
  const open=ref<boolean>(false)
  let model=reactive<any>({title:'名称',cname:'',ordernum:0,id:0,enable:true})
  const rules={
    title:{domtype:'input',name:'名称',required:true},
    cname:{domtype:'input',name:'别名',desc:'这里是对应前端页面名称',required:true},
    url:{domtype:'imput',name:'图标'},
    enable:{domtype:'switch',name:'启用',value:true},
    ordernum:{domtype:'number',name:'排序',value:10},
  }
  onMounted(()=>{
    getList()
  })
  const form=ref(null)
  const getList=():void=>{
      api.menu.list({}).then(res=>{
        dataList.value=res.data
      })
  }
  const onAdd=(id:number):void=>{
    model={title:'',cname:'',ordernum:0,ID:0,pid:id,enable:true,desc:'',url:'bx-analyse'}
    open.value=true
  }
  const onEdit=(id:number):void=>{
    api.menu.get({id:id}).then(res=>{
        model=res.data
        open.value=true
        getList()
    })
  }
  const onDel=(id:number):void=>{
    api.menu.del({id:id}).then(res=>{
        getList()
    })
  }
  const submit=(d:object):void=>{
    api.menu.add(d).then(res=>{
      open.value=false
      getList()
    })
  }
</script>
<style lang='less'>
  .ant-tree-treenode{height:40px;}
</style>
